jQuery('.slider').slick({
	dots: true
});
